import '../../assets/index26.css';var F = Object.defineProperty, G = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var x = Object.prototype.hasOwnProperty, C = Object.prototype.propertyIsEnumerable;
var g = (o, t, e) => t in o ? F(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e, w = (o, t) => {
  for (var e in t || (t = {}))
    x.call(t, e) && g(o, e, t[e]);
  if (m)
    for (var e of m(t))
      C.call(t, e) && g(o, e, t[e]);
  return o;
}, I = (o, t) => G(o, z(t));
var D = (o, t) => {
  var e = {};
  for (var n in o)
    x.call(o, n) && t.indexOf(n) < 0 && (e[n] = o[n]);
  if (o != null && m)
    for (var n of m(o))
      t.indexOf(n) < 0 && C.call(o, n) && (e[n] = o[n]);
  return e;
};
import { jsx as i, jsxs as k } from "react/jsx-runtime";
import { forwardRef as H, useMemo as y } from "react";
import { ErrorMessage as T } from "../../molecules/ErrorMessage/index.js";
import { ComboboxChevron as U } from "../../icons/ComboboxChevron.js";
import { Label as Z } from "../Label/index.js";
import { g as q, a as J, u as K, C as s } from "../../Combobox-5HUj9q7L.js";
import { u as N } from "../../use-uncontrolled-BT_j5D2R.js";
import { I as Q } from "../../InputBase-Cabx1d9o.js";
import { I as V } from "../../Input--FNE961U.js";
const X = "Select-module__root___5RGau", Y = "Select-module__inputWrapper___VLLot", oo = "Select-module__inputBaseInput___CRl2G", to = "Select-module__options___onC92", eo = "Select-module__option___HnZ5k", c = {
  root: X,
  inputWrapper: Y,
  inputBaseInput: oo,
  options: to,
  option: eo
}, no = H(
  (ro, R) => {
    var f = ro, {
      allowDeselect: o = !0,
      defaultValue: t,
      description: e,
      disabled: n,
      error: l,
      data: h,
      label: S,
      placeholder: $,
      onChange: B,
      value: L,
      required: P,
      className: a,
      width: W,
      children: j
    } = f, M = D(f, [
      "allowDeselect",
      "defaultValue",
      "description",
      "disabled",
      "error",
      "data",
      "label",
      "placeholder",
      "onChange",
      "value",
      "required",
      "className",
      "width",
      "children"
    ]);
    const _ = y(() => q(h), [h]), O = y(() => J(_), [_]), r = K({
      onDropdownClose: () => r.resetSelectedOption(),
      onDropdownOpen: (p) => {
        p === "keyboard" ? r.selectActiveOption() : r.updateSelectedOptionIndex("active");
      }
    }), [u, v] = N({
      value: L,
      defaultValue: t,
      onChange: B
    }), b = typeof u == "string" ? O[u] : void 0, A = (p) => {
      const d = O[p];
      if (o && p === u) {
        v("", d), r.updateSelectedOptionIndex("active"), r.closeDropdown();
        return;
      }
      v(p, d), r.updateSelectedOptionIndex("active"), r.closeDropdown();
    }, E = _.map((p, d) => /* @__PURE__ */ i(
      s.Option,
      {
        active: p.value === u,
        value: p.value,
        onMouseOver: () => r.selectOption(d),
        className: c.option,
        disabled: p.disabled,
        children: p.label
      },
      p.value
    ));
    return /* @__PURE__ */ k(s, { store: r, onOptionSubmit: A, withinPortal: !1, disabled: n, children: [
      /* @__PURE__ */ i(s.Target, { children: /* @__PURE__ */ i(
        Q,
        I(w({
          disabled: n,
          component: "button",
          type: "button",
          onClick: () => r.toggleDropdown(),
          pointer: !0,
          rightSection: /* @__PURE__ */ i(U, { size: "xs", error: l }),
          rightSectionPointerEvents: "none",
          label: /* @__PURE__ */ i(Z, { label: S, withAsterisk: P }),
          description: e,
          descriptionProps: { c: "gray.8" },
          error: l && /* @__PURE__ */ i(T, { error: l }),
          inputWrapperOrder: ["label", "input", l ? "error" : "description"],
          classNames: {
            wrapper: `${c.inputWrapper} ${a ? a + "-wrapper" : ""}`,
            input: `${c.inputBaseInput} ${a ? a + "-input" : ""}`,
            root: `${c.root} ${a || ""}`
          },
          style: { width: W },
          ref: R
        }, M), {
          children: (b == null ? void 0 : b.label) || /* @__PURE__ */ i(V.Placeholder, { children: $ })
        })
      ) }),
      /* @__PURE__ */ k(s.Dropdown, { children: [
        /* @__PURE__ */ i(s.Options, { "aria-label": S, className: c.options, children: E }),
        j
      ] })
    ] });
  }
), po = Object.assign(no, {
  Footer: s.Footer
});
po.displayName = "Select";
export {
  po as Select
};
